import styled from 'styled-components';

type WrapperProps = {
  backgroundColor: string,
  width?: string,
};

const Wrapper = styled.div<WrapperProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    width: ${(props) => props.width};
    gap: 4px;
    min-width: ${(props) => props.width || '85px'};
    max-width: ${(props) => props.width || 'fit-content'};
    height: 26px;
    border-radius: 6px;
    background-color: ${(props) => props.backgroundColor};
    color: ${(props) => props.theme.colors.black};
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};

    .status-icon {
      display: inline-flex;
      width: 14px;
      height: 14px;

      svg {
        width: 14px;
        height: 14px;
      }
    }

    p {
      font-size: 13px;
      color: ${(props) => props.theme.colors.black};
      cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
    }
`;

export default { Wrapper };
